import { ProCard, ProDescriptions } from '@ant-design/pro-components'
import { localQueryEntityOptions } from '@app/icare/client/db/client/localQueryOneOptions'
import { teamNameForGroup } from '@app/icare/entities/adTeam/schema/ADTeam'
import { UserRoleEnum } from '@app/icare/entities/user/schema/User'
import { EmployeeEditDrawer } from '@app/icare/routes/_app/mitarbeiter/-components/EmployeeEditDrawer'
import { t } from '@lingui/core/macro'
import { Trans } from '@lingui/react/macro'
import { EditSectionButton } from '@pkg/ui/button'
import { TypedDescriptionsItem } from '@pkg/ui/proValueTypes'
import { useQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { Flex, Tag } from 'antd'

export const Route = createFileRoute('/_app/mitarbeiter/$id/')({
  component: RouteComponent,
})

const isUserRole = (role: string): role is typeof UserRoleEnum.$.Type =>
  UserRoleEnum.$.values.some(value => value === role)

function RouteComponent() {
  const params = Route.useParams()
  const { data } = useQuery(localQueryEntityOptions(params.id))

  if (!data) {
    return <ProCard loading />
  }

  const user = data
  const allRoles = user.roles ?? []
  const roles = allRoles.filter(isUserRole)
  const teams = allRoles.filter(group => group.startsWith('CARE_Team_'))

  return (
    <Flex vertical gap="small">
      <ProCard headerBordered title={t`Allgemein`}>
        <ProDescriptions column={1} size="small" colon={false}>
          <TypedDescriptionsItem label={t`Vorname`}>{user.firstName}</TypedDescriptionsItem>
          <TypedDescriptionsItem label={t`Nachname`}>{user.lastName}</TypedDescriptionsItem>
          <TypedDescriptionsItem label={t`Rollen`}>
            {roles.length > 0 ? (
              roles.map(role => (
                <Tag key={role} color="blue">
                  {UserRoleEnum.$.getLabel(role)}
                </Tag>
              ))
            ) : (
              <span className="text-gray-400">
                <Trans>Keine Rollen</Trans>
              </span>
            )}
          </TypedDescriptionsItem>
          <TypedDescriptionsItem label={t`Teams`}>
            {teams.length > 0 ? (
              teams.map(group => (
                <Tag key={group} color="geekblue">
                  {teamNameForGroup(group)}
                </Tag>
              ))
            ) : (
              <span className="text-gray-400">
                <Trans>Keine Teams</Trans>
              </span>
            )}
          </TypedDescriptionsItem>
        </ProDescriptions>
      </ProCard>
      <ProCard
        headerBordered
        title={t`Kontakt`}
        extra={<EditSectionButton onClick={() => void EmployeeEditDrawer.show({ id: user.id, section: 'contact' })} />}
      >
        <ProDescriptions column={1} size="small" colon={false}>
          <TypedDescriptionsItem label={t`Telefon`} valueType="phoneLink">
            {user.phone ?? undefined}
          </TypedDescriptionsItem>
          <TypedDescriptionsItem label={t`Mobil`} valueType="mobileLink">
            {user.mobile ?? undefined}
          </TypedDescriptionsItem>
          <TypedDescriptionsItem label={t`Fax`} valueType="faxLink">
            {user.fax ?? undefined}
          </TypedDescriptionsItem>
          <TypedDescriptionsItem label={t`E-Mail`} valueType="emailLink">
            {user.email}
          </TypedDescriptionsItem>
        </ProDescriptions>
      </ProCard>
    </Flex>
  )
}
